/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { Navbar } from "../../components/navbar";
import ExclamationMark from "../../assets/icons/exclamation-mark.png";
import Arrow from "@material-ui/icons/ArrowBack"
import IIcon from "../../assets/icons/i-icon.png"
import { RefDialogBox } from "../../components/refDialog";
import { ImgModalBox } from "../../components/imgModal";
import "./styles.scss";
import { HeroStatMenuList } from "../../components/heroStatMenuList";
import { useNavigate } from "react-router-dom";
import { AuthService } from "../../services/auth.service";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/Reducer";
import { STATUS } from "../../common/constant";
import Pagination from "../../components/Pagination";
import Loader from "../../components/Loader";

export const AccountPage: React.FC = () => {

    const messages = ["This is the total number of incidents that you have reported and the incidents that have been reported to you",
        "This is the total number of missions, both reported by you and reported to you that has resulted in either the driver/you being able to avoida parking ticket",
        "This is the total number of people who have used your referral code during registration",
        "You can use your Rescue Log to keep track of Parking Hero rescue operations. When you send another user a notifcation or someone else sends you a notifcation it is logged here"]


    const [page, setPage] = useState<number>(1);
    const [data, setData] = useState<any>();
    const [limit] = useState<number>(5);
    const [show1, setShow1] = useState<any>(false)
    const [show2, setShow2] = useState<any>(false)
    const [show3, setShow3] = useState<any>(false)
    const [show4, setShow4] = useState<any>(false)
    const anchorRef1 = useRef<any>(null);
    const anchorRef2 = useRef<any>(null);
    const anchorRef3 = useRef<any>(null);
    const anchorRef4 = useRef<any>(null);
    const [show, setShow] = useState<boolean>(false)
    const [showImg, setShowImg] = useState<boolean>(false)
    const [img, setImg] = useState<any | null>(null)
    const authenticationService = new AuthService();
    const userData: any = useSelector<RootState>((state) => state?.authData?.authData)
    const [count, setCount] = useState<number>(0)
    const [loader, setLoader] = useState<boolean>(false)

    const getAccount = async () => {
        try {
            setLoader(true)
            const accountResponse: any = await authenticationService.getAccount(userData.user_id, page, limit);
            if (accountResponse.status === STATUS.SUCCESS) {
                setData(accountResponse.data.account_details)
                setCount(Math.ceil(accountResponse.data.total / 5))
                setLoader(false)
            }
        }
        catch (error) {

        }
    }

    const offers = async () => {
        try {
            const offerResponse: any = await authenticationService.Offers(userData.user_id);
            if (offerResponse.status === STATUS.SUCCESS) {
                console.log(offerResponse.data.Account_details)
            }
        } catch (error) {

        }
    }

    useEffect(() => {
        getAccount()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page])

    const navigate = useNavigate()

    const handleIncident = (eve: any, ele: any) => {
        if (!!eve.target?.src) {
            //pass
        } else {
            navigate("/incidentDetails", { state: ele })
        }
    }

    const handleImgModal = () => {
        setShowImg(true)
    }

    useEffect(() => {
        getAccount()
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <div className="account-page">
                <Navbar noAds={true} account={true} />
                <h5 className="account-heading">ACCOUNT</h5>
                <div className="account-con">
                    <div className="btn-wraper" >
                        <div className="acc-btn">
                            <button className="acc-btn-btn btn" onClick={() => { navigate("/qrCode") }} >QR Code</button>
                        </div>
                        <div className="acc-btn">
                            <button className="acc-btn-btn btn" onClick={() => setShow(true)} >Share Referral code</button>
                        </div>
                        <div className="acc-btn">
                            <button className="acc-btn-btn btn" onClick={() => {
                                offers()
                            }} >Your Offers</button>
                        </div>
                    </div>
                    <div className="table" >
                        <div className="table-header-wraper">
                            <h5 className="account-table-heading">PH Rescue Log</h5>
                            <img src={ExclamationMark} onMouseEnter={() => setShow4(true)} onMouseLeave={() => setShow4(false)} ref={anchorRef4} alt="not found" />
                            <HeroStatMenuList show={show4} setShow={setShow4} position={"left top"} anchorRef={anchorRef4} message={messages[3]} />
                        </div>
                        <div >
                            <table className="table-wraper">
                                <thead className="head-wraper">
                                    <tr>
                                        <th style={{ width: "15%" }} ><p>Incident Details</p></th>
                                        <th style={{ width: "25%" }}><p>Attachments</p></th>
                                        <th style={{ width: "25%" }}><p>Comments</p></th>
                                        <th style={{ width: "20%" }}><p>Date</p></th>
                                        <th style={{ width: "15%" }}><p>Reported by</p></th>
                                    </tr>
                                </thead>
                                {data?.map((element: any, index: number) => {
                                    return (
                                        <tbody
                                            key={index}
                                            id={`${index}`}
                                            onClick={(event: any) => { handleIncident(event, element) }}
                                            className="body-wraper" style={index % 2 ? { backgroundColor: "#F1F0F0", cursor: "pointer" } : { backgroundColor: "white", cursor: "pointer" }}
                                        // onMouseOver={(event) => {console.log(event.target)}}
                                        >
                                            <tr style={{ width: "15%", display: "flex", justifyContent: "center" }}><td>{element.incident_details}</td></tr>
                                            <tr style={{ width: "25%", display: "flex", justifyContent: "center" }}>
                                                <td>
                                                    {element.attachments ?
                                                        <img src={element.attachments} className="attachment-img" onClick={() => { setImg(element.attachments); handleImgModal(); }} alt="Not found" />
                                                        : <p>No Attachments Provided</p>
                                                    }
                                                </td>
                                            </tr>
                                            <tr style={{ display: "flex", justifyContent: "center", width: "25%" }}><td>{element.comments}</td></tr>
                                            <tr style={{ display: "flex", justifyContent: "center", width: "20%" }}><td>{element.data}</td></tr>
                                            <tr style={{ display: "flex", width: "15%", justifyContent: "center" }}><td>{element.by}</td></tr>
                                        </tbody>
                                    )
                                })}
                            </table>
                        </div>
                        <Pagination setPage={setPage} page={page} count={count} />
                        <div className="table-header-wraper">
                            <h5 className="account-table-heading" style={{ fontWeight: 700 }}>Hero Stats</h5>
                        </div>
                        <table className="table-wraper">
                            <thead>
                                <tr className="head-wraper">
                                    <th style={{ width: "25%" }} ><p>Hero Status</p></th>
                                    <th style={{ width: "50%" }}></th>
                                    <th style={{ width: "25%" }}><p>Number</p></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="body-wraper" style={{ backgroundColor: "white", width: "100%" }}>
                                    <td className="body-content" style={{ display: "flex", justifyContent: "center", width: "25%" }} >
                                        <p>Total Parking Hero Missions</p>
                                        <img ref={anchorRef1} onMouseEnter={() => setShow1(true)} onMouseLeave={() => setShow1(false)} src={IIcon} alt="not found" />
                                        <HeroStatMenuList show={show1} setShow={setShow1} anchorRef={anchorRef1} message={messages[0]} />
                                    </td>
                                    <td style={{ width: "50%" }}></td>
                                    <td style={{ textAlign: "center", width: "25%" }}>
                                        <p>20</p>
                                    </td>
                                </tr>
                                <tr className="body-wraper" style={{ backgroundColor: "#F1F0F0" }}>
                                    <td className="body-content" style={{ display: "flex", justifyContent: "center", width: "25%" }}>
                                        <p>Successful Parking Hero Missions</p>
                                        <img ref={anchorRef2} onMouseEnter={() => setShow2(true)} onMouseLeave={() => setShow2(false)} src={IIcon} alt="not found" />
                                        <HeroStatMenuList show={show2} setShow={setShow2} anchorRef={anchorRef2} message={messages[1]} />
                                    </td>
                                    <td style={{ width: "50%" }}></td>
                                    <td style={{ width: "25%" }}>
                                        <div className="sub-table" >
                                            <div className="sub-table-body">
                                                <table>
                                                    <tbody>
                                                        <tr style={{ width: "50%" }}><td>Send </td>
                                                            <td><Arrow style={{ transform: "rotate(90deg)" }} /></td><td> 5</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="sub-table-body">
                                                <table>
                                                    <tbody>
                                                        <tr style={{ width: "50%" }}><td>Received </td>
                                                            <td><Arrow style={{ transform: "rotate(-90deg)" }} /> </td><td> 5</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="body-wraper" style={{ backgroundColor: "white" }}>
                                    <td className="body-content" style={{ display: "flex", width: "25%", justifyContent: "center" }} >
                                        <p>Referrals </p>
                                        <img ref={anchorRef3} onMouseEnter={() => setShow3(true)} onMouseLeave={() => setShow3(false)} src={IIcon} alt="not found" />
                                        <HeroStatMenuList show={show3} setShow={setShow3} anchorRef={anchorRef3} message={messages[2]} />
                                    </td>
                                    <td style={{ width: "50%" }}></td>
                                    <td style={{ width: "25%" }}><p>5</p></td>
                                </tr>
                            </tbody>
                        </table>
                    </div >
                </div >
                <div className="add-con">
                </div>
                {show && <RefDialogBox show={show} setShow={setShow} />}
                {showImg && <ImgModalBox show={showImg} setShow={setShowImg} img={img} />}
                {loader && <Loader />}
            </div >
        </>
    )
}